import React from 'react';
import { Icon, Text, type IconName } from '@upsales/components';
import BemClass from '@upsales/components/Utils/bemClass';
import type { VisitStatus } from 'App/helpers/visits/visitStatus';

import './VisitStatusBadge.scss';

// Told apart by shape as well as colour, so the three still read without colour vision.
const ICONS: Record<VisitStatus, IconName> = {
	visited: 'check',
	planned: 'clock-o',
	none: 'minus'
};

type BadgeProps = { status: VisitStatus; className?: string; small?: boolean };

export const VisitStatusBadge = ({ status, className, small = false }: BadgeProps) => (
	<span
		aria-hidden
		data-visit-status={status}
		className={new BemClass('VisitStatusBadge', className).mod({ [status]: true, small }).b()}
	>
		<Icon name={ICONS[status]} color="white" />
	</span>
);

export const VisitStatusChip = ({ status, label }: { status: VisitStatus; label: string }) => (
	<span data-visit-chip={status} className="VisitStatusChip">
		<VisitStatusBadge status={status} small />
		<Text size="sm" bold color="grey-13">
			{label}
		</Text>
	</span>
);
